/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const deleteAccountDataSchema = z.object({
  deleted: z.boolean(),
});

export type IDeleteAccountData = z.infer<typeof deleteAccountDataSchema>;

export const deleteAccountResponseSchema = createApiResponseSchema(
  deleteAccountDataSchema,
) as z.ZodSchema<IAPI<IDeleteAccountData>>;

export type IDeleteAccountResponse = IAPI<IDeleteAccountData>;
